'use client'

import { useBreakpoint } from '@qr-front/ui/hooks'
import { cn, getVersionForClone } from '@qr-front/ui/utils'
import Image from 'next/image'

type TLogo = {
	id: number
	src: string
	alt: string
	width: number
	height: number
}

const baseLogos: TLogo[] = [
	{
		id: 1,
		src: '/web-app/landing/logo-showcase/marriott.svg',
		alt: 'Marriott',
		width: 76,
		height: 24,
	},
	{
		id: 2,
		src: '/web-app/landing/logo-showcase/dhl.svg',
		alt: 'DHL',
		width: 128,
		height: 24,
	},
	{
		id: 3,
		src: '/web-app/landing/logo-showcase/adidas.svg',
		alt: 'Adidas',
		width: 35,
		height: 24,
	},
	{
		id: 4,
		src: '/web-app/landing/logo-showcase/hilton.svg',
		alt: 'Hilton',
		width: 65,
		height: 24,
	},
	{
		id: 5,
		src: '/web-app/landing/logo-showcase/nestle.svg',
		alt: 'Nestlé',
		width: 87,
		height: 24,
	},
	{
		id: 6,
		src: '/web-app/landing/logo-showcase/loreal.svg',
		alt: "L'Oréal",
		width: 100,
		height: 18,
	},
]

const clone1Logos: TLogo[] = [
	{
		id: 1,
		src: '/web-app/landing/brand-logos/hyatt-logo.svg',
		alt: 'Hyatt',
		width: 99,
		height: 24,
	},
	{
		id: 2,
		src: '/web-app/landing/brand-logos/sheraton-logo.svg',
		alt: 'Sheraton',
		width: 52,
		height: 24,
	},
	{
		id: 3,
		src: '/web-app/landing/brand-logos/philips-logo.svg',
		alt: 'Philips',
		width: 120,
		height: 24,
	},
	{
		id: 4,
		src: '/web-app/landing/brand-logos/fedex-express-logo.svg',
		alt: 'FedEx Express',
		width: 53,
		height: 24,
	},
	{
		id: 5,
		src: '/web-app/landing/brand-logos/pfizer-logo.svg',
		alt: 'Pfizer',
		width: 41,
		height: 24,
	},
	{
		id: 6,
		src: '/web-app/landing/brand-logos/lenovo-logo.svg',
		alt: 'Lenovo',
		width: 114,
		height: 24,
	},
]

const logos = getVersionForClone({ base: baseLogos, clone1: clone1Logos })

export const BrandLogosWrapper = () => {
	const isTablet = useBreakpoint('tablet', { ssrFallback: false })

	return (
		<>
			{Array.from({ length: 6 }).flatMap((_, loopIndex) =>
				logos.map(({ id, src, alt, width, height }, index) => (
					<div
						key={`${id}-${loopIndex}-${index}`}
						className={cn(
							'inline-flex shrink-0 px-3 desktop:px-6',
							getVersionForClone({
								base: 'opacity-40',
								clone1: '',
							}),
						)}
						aria-label={alt}
					>
						<Image
							src={src}
							alt={alt}
							width={width}
							height={height}
							style={{ width, height }}
							loading={
								isTablet && loopIndex === 0 ? 'eager' : 'lazy'
							}
							priority={isTablet && loopIndex === 0}
							fetchPriority={
								isTablet && loopIndex === 0 ? 'high' : 'low'
							}
							decoding={
								isTablet && loopIndex === 0 ? 'sync' : 'async'
							}
							unoptimized
							aria-hidden="true"
						/>
					</div>
				)),
			)}
		</>
	)
}
